import { render, staticRenderFns } from "./claimListDlg.vue?vue&type=template&id=b9a4650e&scoped=true"
import script from "./claimListDlg.vue?vue&type=script&lang=js"
export * from "./claimListDlg.vue?vue&type=script&lang=js"
import style0 from "./claimListDlg.vue?vue&type=style&index=0&id=b9a4650e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9a4650e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9a4650e')) {
      api.createRecord('b9a4650e', component.options)
    } else {
      api.reload('b9a4650e', component.options)
    }
    module.hot.accept("./claimListDlg.vue?vue&type=template&id=b9a4650e&scoped=true", function () {
      api.rerender('b9a4650e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopOperationCenter/dialog/claimListDlg.vue"
export default component.exports